/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAuditElevatedRequestsResponse } from '../../models/get-audit-elevated-requests-response';

export interface GetAuditElevatedRequests$Params {
	organizationId?: string;
	inactive?: boolean;
	startdate?: string;
	enddate?: string;
	page?: number;
	pagesize?: number;
	sort?: string;
}

export function getAuditElevatedRequests(
	http: HttpClient,
	rootUrl: string,
	params?: GetAuditElevatedRequests$Params,
	context?: HttpContext
): Observable<StrictHttpResponse<GetAuditElevatedRequestsResponse>> {
	const rb = new RequestBuilder(rootUrl, getAuditElevatedRequests.PATH, 'get');
	if (params) {
		rb.query('organizationId', params.organizationId, {});
		rb.query('inactive', params.inactive, {});
		rb.query('startdate', params.startdate, {});
		rb.query('enddate', params.enddate, {});
		rb.query('page', params.page, {});
		rb.query('pagesize', params.pagesize, {});
		rb.query('sort', params.sort, {});
	}

	return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
		filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
		map((r: HttpResponse<any>) => {
			return r as StrictHttpResponse<GetAuditElevatedRequestsResponse>;
		})
	);
}

getAuditElevatedRequests.PATH = '/api/v1/elevatedrequest/audit';
